import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { claimStatusOptions } from './constants'

const ClaimStatusSelector = ({ onChange, value = [] }) => {
  const { t } = useTranslation()

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <ComboBox
      value={value || []}
      label={t('Estado de la incidencia')}
      fullWidth
      multiple
      handleChange={handleChange}
      menuItems={claimStatusOptions.map(option => ({ label: t(option.label), value: option.value }))}
      placeholder={t('Todos')}
    />
  )
}

export default ClaimStatusSelector
